module.exports = __webpack_public_path__ + "img/ds.9e298d9d.svg";